import { RootState } from "@/store/dtm";
import { addressType } from "@/types/addressType";
import { employmentType } from "@/types/employmentType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface currentEmploymentInfo extends employmentType{
    displayId: string,
    visible: boolean,
    noRetirementIncome: boolean,
    incomeText: string,
    overtimeIncomeText: string,
    bonusIncomeText: string,
    commissionIncomeText: string,
    tipsIncomeText: string,
    otherIncome: IncomeInfo[],
    employerAddress: employerAddressInfo,
    manualAddressEntered: boolean,
}

export interface currentEmploymentState {
    employments: currentEmploymentInfo[]
}

export interface employerAddressInfo extends addressType {
    displayId: string,
}

export interface IncomeInfo {
    id: number,
    displayId: string,
    type: string,
    amount: number,
    amountText: string,
    frequency: string
}

const initialState: currentEmploymentState = {
    employments: []
}


export const currentEmploymentSlice = createSlice({
    name: "currentEmployment",
    initialState,
    reducers: {
        addCurrentEmployment: (state, action: PayloadAction<currentEmploymentInfo>) => {
            const employment = action.payload;
            state.employments.push(employment);
        },
        setCurrentEmploymentInfo: (state, action: PayloadAction<currentEmploymentInfo>) => {
            const empInfo = action.payload;
            state.employments = state.employments.map(emp => emp.displayId == empInfo.displayId ? empInfo : emp);
        },
        removeCurrentEmployment: (state, action: PayloadAction<string>) => {
            const id = action.payload;
            state.employments = state.employments.filter(employment => employment.displayId != id);

            //Reset the displayId of remaining employments
            state.employments = state.employments.map((employment, index) => ({
                ...employment,
                displayId: `${index + 1}`
            }));
        },
        clearCurrentEmploymentState: (state) => {
            state.employments = []
        }
    }
});

export const { addCurrentEmployment, setCurrentEmploymentInfo, removeCurrentEmployment, clearCurrentEmploymentState } = currentEmploymentSlice.actions

export default currentEmploymentSlice.reducer

export const selectCurrentEmployment = (state: RootState) => state.currentEmployment;

